<template>
  <div>
    <h1>Page for Redirecting</h1>
    <p>{{ pathParse }}</p>
  </div>
</template>

<script>
import { parseParams } from "@/utils/routeParsing";

export default {
  name: "RedirectPage",
  setup(props, { root }) {
    const path = root.$route.params.pathMatch;
    const pathParse = parseParams(path, root.$route.query);

    return {
      pathParse,
    };
  },
};
</script>
